<div class="min-h-[80vh] w-full">
  <div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
      <div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">ایران هتل
        </h1>
        <h2 class="text-white fs-1.6"> حریم شخصی      </h2>
        <img src="/assets/images/privacy-bg.svg" width="500" height="250" alt="image"
          class="full-img d-block absolute left-0 bottom-0" fetchpriority="high">
      </div>

    </div>
  </div>
  <div class="container">
    <div class="w-full  mt-10">
      <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
          <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
            *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
            <ng-container *ngIf="!last">
              <a [href]="first ? '/' : bread['@id']">
                {{ bread.name }}
              </a>
            </ng-container>
            <ng-container *ngIf="last">
              <span class=""> {{ bread.name }} </span>
            </ng-container>

          </li>
        </ol>
      </nav>   
    </div>
    <div class="w-full  mt-10">
      <h4 class="font-bold mt-5 title-content">
        حریم شخصی
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        مجریان سايت ايران هتل آنلاين(آي هو)، خود را متعهد به حفاظت از حریم خصوصی همه بازدیدکنندگان
        www.IranHotelOnline.com
        می
        دانند و ما به عنوان بخشی از تعهد خود نسبت به حریم خصوصی شما این بیانیه محرمانگی را تهیه کرده ایم. شما به عنوان
        مشتری
        ما
        می توانید بدون نیاز به وارد کردن هرگونه اطلاعات شخصی در شبکه جهانی اینترنت از سایت www.IranHotelOnline.com
        بازدید
        کنید.
        مقدار اطلاعاتی که جمع آوری می کنیم به اطلاعاتی که شما در اختیار ما قرار می دهید، بستگی دارد.
      </p>
      <b>با ثبت یا درخواست اطلاعات در این سایت، شما اجازه می دهید تا اطلاعات شما بر اساس مفاد این خط مشی جمع آوری،
        استفاده و
        منتقل شود.
      </b>
      <h4 class="font-bold mt-5 title-content">
        اطلاعاتی که ما از شما جمع آوری می کنیم
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        هنگام بازدید از www.IranHotelOnline.com از شما خواسته می شود که اطلاعاتی نظیر نام و جزئیات تماس خود را وارد
        کنید.
        همچنین ممکن است ما اطلاعاتی درباره استفاده شما از سایت را در کنار اطلاعاتی.که بوسیله نامه و یا ایمیل برای ما می
        فرستید، جمع آوری کنیم.
      </p>
      <h4 class="font-bold mt-5 title-content">
        اطلاعاتی که ما از شما جمع آوری می کنیم
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        هنگام بازدید از www.IranHotelOnline.com از شما خواسته می شود که اطلاعاتی نظیر نام و جزئیات تماس خود را وارد
        کنید.
        همچنین ممکن است ما اطلاعاتی درباره استفاده شما از سایت را در کنار اطلاعاتی.که بوسیله نامه و یا ایمیل برای ما می
        فرستید، جمع آوری کنیم.
      </p>
      <h4 class="font-bold mt-5 title-content">
    افشاء 
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
      اطلاعاتی که در اختیار ما قرار می دهید در سرورهای امن ما قرار می گیرد. همچنین ممکن است ما اطلاعات جمع آوری شده درباره
      استفاده از سایت خود را در اختیار اشخاص ثالثی قرار دهیم اما این موارد شامل اطلاعاتی که قابل استفاده برای تعیین هویت شما
      باشند نخواهد بود. هر جا که رمز ورودی به شما ارائه شده (یا خود انتخاب کرده اید)، این رمز ورود شما را قادر خواهد ساخت تا
      به بخش های مشخصی از سایت آي هو دسترسی داشته باشید، حفظ و نگهداری از این رمز ورود بر عهده شخص شما خواهد بود. ما از شما می
      خواهیم تا این رمز ورود را در اختیار هیچ کس قرار ندهید. متاسفانه انتقال اطلاعات از طریق اینترنت کاملاً امن نیست. علی رغم
      اینکه ما همه تلاشمان را جهت حفاظت از اطلاعات شخصی شما به کار می گیریم، نمی توانیم امنیت انتقال اطلاعات شما را تضمین
      کنیم؛ بنابراین مسئولیت هرگونه انتقال بر عهده شما كاربر گرامي خواهد بود. با دریافت اطلاعات شما، ما از روش های سخت گیرانه
      و امنیتی در جهت تلاش برای جلوگیری از دسترسی غیر مجاز به آن ها استفاده خواهیم کرد. کشورهای خارج از جامعه اقتصادی اروپا
      همیشه قوانین حفاظت اطلاعات قوی ندارند. به هر حال ما همیشه برای اطمینان از اینکه اطلاعات شما مطابق این خط مشی استفاده شود
      تلاش خواهیم کرد. مگر در مواردی که قانون ملزم بداند، ما هیچ بخشی از اطلاعاتی که شما در اختیارمان گذارده اید را در اختیار
      دیگران نگذاشته، به فروش نرسانده و توزیع نخواهیم کرد. در پایان اگر تجارت ما وارد سرمایه گذاری مشترک با شرکت دیگری شده و
      یا با موسسه ای دیگر ادغام .یا به آن فروخته شود، اطلاعات شما به شرکا یا مالکان جدید اعلام خواهد شد.
      </p>
      <h4 class="font-bold mt-5 title-content">
        ها و کوکی ها IP
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        ما ممکن است اطلاعات کامپیوتر شما، از جمله آدرس های IP سیستم عامل، زمان بازديد در هر صفحه و نوع مرورگر را جمع آوری کرده و
        جهت مدیریت و اهداف بازاریابی مورد استفاده قرار دهیم. این امر شامل داده های آماری درباره الگوها و عملکرد جستجوی شما در
        اینترنت بوده و نمی تواند هویت شما را تعیین کند کوکی ها بسته های کوچک اطلاعاتی هستند که ما روی کامپیوتر شما ذخیره می
        کنیم. هنگامی که شما وارد سایت ما می شوید، سیستم ما کوکی هایی را روی کامپیوتر شما ذخیره خواهد کرد. مگر اینکه مخالفت خود
        را هنگام ارائه اطلاعات خود به ما اعلام کرده باشید. کوکی ها به دفعات بعدی بازدید از سایت سرعت بیشتری می دهند. همچنین کوکی
        ها به ما اجازه می دهند تا بتوانیم ترافیک سایت را کنترل و نظارت کرده و محتوای سایت را برای شما شخصی سازی کنیم. شما می
        توانید با فعال کردن تنظیمات خاص در مرورگر کامپیوتر خود از ذخیره کوکی ها جلوگیری کنید، در این صورت ممکن است نتوانید از
        برخی قابلیت های ویژه سایت ما استفاده نمایید.
        </p>
        <h4 class="font-bold mt-5 title-content">
          امنیت و حفاظت از داده ها
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        ما از اقدامات امنیتی استفاده می کنیم تا اطلاعات شما را از دسترسی اشخاص غیر مجاز و عملکردهای غیر قانونی، خسارات اتفاقی،
        تخریب و نقصان مصون نگاه داریم. ما اطلاعات شما را برای مدتی متعارف که قانون ملزم می داند، نگاه خواهیم داشت. در موارد خاص
        ممکن است سایت ما حاوی لینک های الکترونیکی به سایت های دیگر باشد. در صورتی که بخواهید از این سایت ها بازدید کنید، خط مشی
        حفظ حریم خصوصی و اولویت های حریم خصوصی آن ها معتبر خواهد بود.
      </p>
      <h4 class="font-bold mt-5 title-content">
        دسترسی و به روزآوری
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        شما این حق را دارید که از اطلاعات نگهداری شده خود آگاهی داشته و از ما بخواهید تا تغییراتی در آن ها ایجاد کنیم تا دقیق و
        به روز باشند. اگر به این امر تمایل داشتید، ما را در جریان بگذارید.

      </p>
      <h4 class="font-bold mt-5 title-content">
        تغییرات در خط مشی حفظ حریم خصوصی ما
      </h4>
      <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
        هرگونه تغییرات آتی در خط مشی حفظ حریم خصوصی ما بر روی سایت قرار خواهد گرفت و در صورت نیاز از طریق ایمیل نیز اطلاع رسانی
        خواهد شد.

      </p>
    </div>
  </div>

</div>